import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

interface InputTextareaProps {
	placeholder?: string;
	input?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
	value?: string;
	name?: string;
	id?: string;
	isError?: boolean;
	maxLength?: number;
	minHeight?: string;
	disabled?: boolean;
}

const InputTextarea = forwardRef<HTMLTextAreaElement, InputTextareaProps>(
	({ placeholder, input, value, name, id, isError, maxLength, minHeight, disabled }, ref) => {
		const { t } = useTranslation();

		return (
			<S.Container>
				<S.TextareaInput
					ref={ref}
					id={id}
					name={name}
					placeholder={placeholder ? t(placeholder) : undefined}
					onChange={input}
					value={value}
					isError={isError}
					maxLength={maxLength}
					$minHeight={minHeight}
					disabled={disabled}
				/>
			</S.Container>
		);
	}
);

InputTextarea.displayName = 'InputTextarea';

export default InputTextarea;
